import { useOptionSaleStartBeforeDate as useSaleStartBeforeDate } from "@/components/features/items/edit/option/_shared/ui/components/sale-start-before-date/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionSaleStartBeforeDate = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { saleStartBeforeDate } = viewModel;

	return useSaleStartBeforeDate({
		saleStartBeforeDate,
		onSetViewModel,
	});
};
